import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface MobileTabProviderProps {
  children: ReactNode;
}

const MobileTabContext = createContext<any>(null);

export const MobileTabProvider = ({ children }: MobileTabProviderProps) => {
  const [selectedTab, setSelectedTab] = useState('');
  const [selectedDoc, setSelectedDoc] = useState(null);
  const navigate = useNavigate();

  const setTabFromURL = (tabSlug: string) => {
    const tabMap = {
      'soap-notes': 'SOAP Notes',
      'custom-notes': 'Custom Notes',
      reports: 'Reports',
      procedures: 'Procedures',
      letters: 'Letters',
    } as const;

    const key = tabSlug.toLowerCase() as keyof typeof tabMap;
    const matchedTab = tabMap[key];

    if (matchedTab) {
      setSelectedTab(matchedTab);
    }
  };

  const clearTabFromURL = () => {
    // Clear the `routetab` query parameter when navigating away
    navigate(window.location.pathname, { replace: true });
  };

  return (
    <MobileTabContext.Provider
      value={{
        selectedTab,
        setSelectedTab,
        selectedDoc,
        setSelectedDoc,
        setTabFromURL,
        clearTabFromURL,
      }}
    >
      {children}
    </MobileTabContext.Provider>
  );
};

export const useMobileTabContext = () => useContext(MobileTabContext);
